const trimTrailingSlashes = (value: string): string => value.replace(/\/+$/, "");

const rawApiOrigin = import.meta.env.VITE_PUBLIC_API_ORIGIN;
const apiOrigin =
  typeof rawApiOrigin === "string" && rawApiOrigin.trim().length > 0
    ? trimTrailingSlashes(rawApiOrigin.trim())
    : "";

const LEGACY_API_PATH_PREFIXES = ["/projects", "/deployments"] as const;

const toApiPath = (path: string): string => {
  if (path.startsWith("/api/") || path === "/api") return path;
  if (path.startsWith("/internal/") || path === "/internal") return path;
  if (path === "/account/delete") return "/api/account/delete";
  if (LEGACY_API_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return `/api${path}`;
  }
  return path;
};

export const resolveApiUrl = (input: string | URL): string => {
  const raw = input instanceof URL ? input.toString() : input;
  if (!apiOrigin) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  const apiPath = toApiPath(path);
  if (apiPath === path && !path.startsWith("/api/") && !path.startsWith("/internal/")) {
    return raw;
  }
  return `${apiOrigin}${apiPath}`;
};

export const isCrossOriginApiUrl = (url: string): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return new URL(url, window.location.origin).origin !== window.location.origin;
  } catch {
    return false;
  }
};

